import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

export const advP3HighBudget: FaireAdvertiserProfileEntity = {
  token: "adv_p3_high_budget",
  type: "advertiserProfile",
  archetype: "high-budget-strong-results",
  displayName: "Ember & Ash",
  brandToken: "b_adv_p3_high_budget",
  audienceType: "NEW_ONLY",
  globalStatus: "ACTIVE",
  tenureMonths: 33,
  budget: {
    totalBudgetDollars: 1500,
    spendingMode: "COMPETITIVE",
    nextRenewsAtDate: "2026-08-01",
    nextBillsAtDate: "2026-08-04",
  },
  overview: {
    numCustomersAcquired: 110,
    numReorderConversions: 0,
    numTotalConversions: 110,
    totalAdsSalesDollars: 236020,
    newCustomerAdsSalesDollars: 236020,
    totalAdsSpendDollars: 14080,
    newCustomerAdsSpendDollars: 14080,
    newCustomerBestEstimateFirstYearRoas: 16.76,
    combinedFirstYearRoas: 16.76,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 1500,
      maxRecommendedBudgetDollars: 2250,
    },
  },
  campaignTokens: ["camp_p3_high_budget_new"],
  overviewPerformancePeriodTokens: [
    "perf_p3_high_budget_new_202506",
    "perf_p3_high_budget_new_202507",
    "perf_p3_high_budget_new_202508",
    "perf_p3_high_budget_new_202509",
    "perf_p3_high_budget_new_202510",
    "perf_p3_high_budget_new_202511",
    "perf_p3_high_budget_new_202512",
    "perf_p3_high_budget_new_202601",
    "perf_p3_high_budget_new_202602",
    "perf_p3_high_budget_new_202603",
    "perf_p3_high_budget_new_202604",
    "perf_p3_high_budget_new_202605",
    "perf_p3_high_budget_new_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
